<template>
  <v-card :width="$vuetify.breakpoint.mdAndUp ? '50%' : '100%'">
    <v-card-title class="align-start pb-0">
      <v-icon class="mr-5">
        {{ icons.mdiNotePlusOutline }}
      </v-icon>
      Notas del Servicio
    </v-card-title>
    <v-card-text class="mt-2">
      <v-data-table
        :headers="tableColumnHeaders"
        :items="list"
        item-key="noteId"
        hide-default-footer
      >
        <!-- date -->
        <template #[`item.createdOn`]="{item}">
          <div class="d-flex align-center">
            <div class="d-flex flex-column ms-3">
              <span class="d-block text--primary  font-weight-semibold text-truncate">{{ item.createdOn | date(false) }}</span>
              <span class="text-xs">{{ item.user }}</span>
            </div>
          </div>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  ref, onMounted,
} from '@vue/composition-api'
import { mdiNotePlusOutline } from '@mdi/js'
import getNotesList from '@/components/lists/notes'

export default {
  components: {
  },
  props:
    {
      booking: {
        type: Object,
        required: true,
      },

    },
  setup(props) {
    const list = ref([])
    const tableColumnHeaders = [
      {
        text: '#ID',
        align: 'start',
        value: 'noteId',
      },
      { text: 'Fecha/Autor', value: 'createdOn' },
      { text: '', value: 'value' },
    ]

    const refresh = () => {
      getNotesList('bookings', props.booking.bookingKey)
        .then(data => {
          list.value = data
        })
    }

    onMounted(refresh)

    return {
      refresh,

      list,
      tableColumnHeaders,
      icons: { mdiNotePlusOutline },
    }
  },
}
</script>
